import { render, staticRenderFns } from "./otherdetail.vue?vue&type=template&id=7cea4e1f&scoped=true&"
import script from "./otherdetail.vue?vue&type=script&lang=js&"
export * from "./otherdetail.vue?vue&type=script&lang=js&"
import style0 from "./otherdetail.vue?vue&type=style&index=0&id=7cea4e1f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cea4e1f",
  null
  
)

export default component.exports